import React from "react";

const AddIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        id="add_iic"
        d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM5,10a.625.625,0,0,1,.625-.625h3.75V5.625a.625.625,0,0,1,1.25,0v3.75h3.75a.625.625,0,0,1,0,1.25h-3.75v3.75a.625.625,0,0,1-1.25,0v-3.75H5.625A.625.625,0,0,1,5,10Z"
        fill={fill ? fill : "#000"}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default AddIcon;
